import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Opciones.component.scss";



const OpcionesComponent = ({ cambiarOpcion, divOpciones }) => {
  const [actual, setActual] = useState(divOpciones.Productos.id);

  const productosEstilos = (id, estilo, estiloActivo) => {
    let estiloFinal = `${estilo}`;

    if (id === actual) {
      estiloFinal = `${estilo} ${estiloActivo}`;
    }

    return estiloFinal;
  };

  useEffect(() => {
    cambiarOpcion(actual);
  }, [actual]);

  return (
    <div className="Carrito__Opciones">
      <div
        id={divOpciones.Productos.id}
        className={productosEstilos(
          divOpciones.Productos.id,
          divOpciones.Productos.estilo,
          divOpciones.Productos.estiloActivo
        )}
        onClick={() => {
          setActual(divOpciones.Productos.id);
        }}
      >
        <FontAwesomeIcon icon={["fas", "shopping-cart"]} size="lg" />
        <h5>Productos</h5>
        <span></span>
      </div>
      <div
        id={divOpciones.Cliente.id}
        className={productosEstilos(
          divOpciones.Cliente.id,
          divOpciones.Cliente.estilo,
          divOpciones.Cliente.estiloActivo
        )}
        onClick={() => {
          setActual(divOpciones.Cliente.id);
        }}
      >
        <FontAwesomeIcon icon={["fas", "user"]} size="lg" />
        <h5>Datos del cliente</h5>
        <span></span>
      </div>
      <div
        id={divOpciones.Envio.id}
        className={productosEstilos(
          divOpciones.Envio.id,
          divOpciones.Envio.estilo,
          divOpciones.Envio.estiloActivo
        )}
        onClick={() => {
          setActual(divOpciones.Envio.id);
        }}
      >
        <FontAwesomeIcon icon={["fas", "clock"]} size="lg" />
        <h5>Formas de despacho</h5>
        <span></span>
      </div>
      <div
        id={divOpciones.Resumen.id}
        className={productosEstilos(
          divOpciones.Resumen.id,
          divOpciones.Resumen.estilo,
          divOpciones.Resumen.estiloActivo
        )}
        onClick={() => {
          setActual(divOpciones.Resumen.id);
        }}
      >
        <FontAwesomeIcon icon={["fas", "shopping-cart"]} size="lg" />
        <h5>Resumen</h5>
        <span></span>
      </div>
    </div>
  );
};

export default OpcionesComponent;
